module.exports = __webpack_public_path__ + "static/rosebooties-207de7525a97f1fefa0f47e7fff0751b.jpeg";